var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c("div", { staticClass: "d-flex gap-5 groups" }, [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize unitType" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.dateStartOfStartOfTimeUnitType"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: { items: _vm.unitTypes, idKey: "id", labelKey: "label" },
            model: {
              value: _vm.clone.startOf.unit,
              callback: function ($$v) {
                _vm.$set(_vm.clone.startOf, "unit", $$v)
              },
              expression: "clone.startOf.unit",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "From Timezone" },
          model: {
            value: _vm.clone.startOf.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.startOf, "fromTimezone", $$v)
            },
            expression: "clone.startOf.fromTimezone",
          },
        }),
        _vm._v(" "),
        _c("TimezonePickerInput", {
          attrs: { title: "To Timezone" },
          model: {
            value: _vm.clone.startOf.toTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.startOf, "toTimezone", $$v)
            },
            expression: "clone.startOf.toTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.startOf.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.startOf, "fromFormat", $$v)
            },
            expression: "clone.startOf.fromFormat",
          },
        }),
        _vm._v(" "),
        _c("FormatPickerInput", {
          attrs: { title: "To Format" },
          model: {
            value: _vm.clone.startOf.toFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.startOf, "toFormat", $$v)
            },
            expression: "clone.startOf.toFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.startOf.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.startOf, "fromLocale", $$v)
            },
            expression: "clone.startOf.fromLocale",
          },
        }),
        _vm._v(" "),
        _c("LocalePickerInput", {
          attrs: { title: "To Locale" },
          model: {
            value: _vm.clone.startOf.toLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.startOf, "toLocale", $$v)
            },
            expression: "clone.startOf.toLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }